export default "data:video/mp2t;base64,ZXhwb3J0IHR5cGUgT3B0aW9uID0gewogIGxhYmVsOiBzdHJpbmcKICB2YWx1ZTogYW55CiAgZGlzYWJsZWQ/OiBib29sZWFuCn0K"